package one.healthium.profile.ui.food_history

import androidx.compose.ui.util.fastForEach
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format
import kotlinx.datetime.format.char
import one.healthium.base.utils.localizedMonthNames
import kotlinx.datetime.toLocalDateTime
import one.healthium.domain.common.sameYearAsToday
import one.healthium.profile.ui.food_history.models.FoodLogUiModel
import androidx.compose.runtime.Immutable

@Immutable
internal data class FoodHistoryUiState(
    val loading: Boolean = false,
    val foodHistory: List<FoodLogUiModel>? = null,
    val deleteInProgress: Set<String> = emptySet(),
) {
    val uiData: List<Any>? = if (foodHistory == null) {
        null
    } else {
        val currentYearFormatter = dateFormat()
        val lastYearFormatter = dateFormatLastYear()
        var currentDate: String? = null
        buildList {
            foodHistory
                .sortedByDescending { it.date }
                .fastForEach { foodLog ->
                    val foodList = foodLog.food
                        .filterNot { food -> food.id in deleteInProgress }
                        .sortedBy { it.date }

                    if (foodList.isNotEmpty()) {
                        val formatter = if (foodLog.date.sameYearAsToday()) {
                            currentYearFormatter
                        } else {
                            lastYearFormatter
                        }
                        val date = foodLog.date.toLocalDateTime(TimeZone.currentSystemDefault()).format(formatter)

                        if (currentDate != date) {
                            add(date)
                        }
                        currentDate = date

                        addAll(foodList)
                    }
                }
        }
    }
}

private fun dateFormat() = LocalDateTime.Format {
    monthName(localizedMonthNames())
    char(' ')
    day()
}

private fun dateFormatLastYear() = LocalDateTime.Format {
    monthName(localizedMonthNames())
    char(' ')
    day()
    char(' ')
    year()
}
